/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarydeleted2Inputs */

const en_medialibrarydeleted2 = /** @type {(inputs: Medialibrarydeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset deleted.`)
};

const de_medialibrarydeleted2 = /** @type {(inputs: Medialibrarydeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt gelöscht.`)
};

/**
* | output |
* | --- |
* | "Asset deleted." |
*
* @param {Medialibrarydeleted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydeleted2 = /** @type {((inputs?: Medialibrarydeleted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydeleted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydeleted2(inputs)
	return de_medialibrarydeleted2(inputs)
});
export { medialibrarydeleted2 as "mediaLibraryDeleted" }